(function () {
  'use strict';

  var SECTION_SELECTOR = '[data-section-type="home-hero"]';
  var instances = {};

  function HomeHero(container) {
    this.container = container;
    this.video = container.querySelector('.home-hero__media video');
    this.control = container.querySelector('.home-hero__control');

    if (!this.video || !this.control) return;

    this.labelPause = this.control.getAttribute('data-label-pause') || 'Pause background video';
    this.labelPlay = this.control.getAttribute('data-label-play') || 'Play background video';

    this.loopStart = parseFloat(container.getAttribute('data-video-loop-start')) || 0;
    this.loopEnd = parseFloat(container.getAttribute('data-video-loop-end')) || 0;

    this.onClick = this.toggle.bind(this);
    this.onPlay = this.sync.bind(this, true);
    this.onPause = this.sync.bind(this, false);
    this.onTimeUpdate = this.enforceLoopWindow.bind(this);

    this.control.addEventListener('click', this.onClick);
    this.video.addEventListener('play', this.onPlay);
    this.video.addEventListener('pause', this.onPause);

    if (this.loopStart > 0 || this.loopEnd > 0) {
      this.video.addEventListener('timeupdate', this.onTimeUpdate);
      if (this.loopStart > 0) this.seekToStart();
    }

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      this.video.removeAttribute('autoplay');
      this.video.pause();
    }

    this.sync(!this.video.paused);
  }

  HomeHero.prototype.enforceLoopWindow = function () {
    if (this.loopEnd > 0 && this.video.currentTime >= this.loopEnd) {
      this.seekToStart();
    } else if (this.loopStart > 0 && this.video.currentTime < this.loopStart - 0.5) {
      this.seekToStart();
    }
  };

  HomeHero.prototype.seekToStart = function () {
    try {
      this.video.currentTime = this.loopStart;
    } catch (e) {
    }
  };

  HomeHero.prototype.toggle = function () {
    if (this.video.paused) {
      var playing = this.video.play();
      if (playing && typeof playing.catch === 'function') {
        playing.catch(
          function () {
            this.sync(false);
          }.bind(this)
        );
      }
    } else {
      this.video.pause();
    }
  };

  HomeHero.prototype.sync = function (isPlaying) {
    this.control.setAttribute('data-playing', isPlaying ? 'true' : 'false');
    this.control.setAttribute('aria-label', isPlaying ? this.labelPause : this.labelPlay);
  };

  HomeHero.prototype.unload = function () {
    if (!this.video || !this.control) return;
    this.control.removeEventListener('click', this.onClick);
    this.video.removeEventListener('play', this.onPlay);
    this.video.removeEventListener('pause', this.onPause);
    this.video.removeEventListener('timeupdate', this.onTimeUpdate);
  };

  function load(container) {
    if (!container) return;
    var id = container.getAttribute('data-section-id');
    if (!id || instances[id]) return;
    instances[id] = new HomeHero(container);
  }

  function unload(id) {
    if (!instances[id]) return;
    instances[id].unload();
    delete instances[id];
  }

  function initAll() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(load);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    load(event.target.querySelector(SECTION_SELECTOR));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.querySelector(SECTION_SELECTOR);
    if (section) unload(section.getAttribute('data-section-id'));
  });
})();
